import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import CreateQuotation from './views/CreateQuotation.vue'
import Payment from './views/Payment.vue'
import MyDocuments from './views/MyDocuments.vue'
import Home from './views/Home.vue'
import Settings from './views/Settings.vue'
import GetQuotation from './views/GetQuotation.vue'
import ChooseQuotationAction from './views/ChooseQuotationAction.vue'
import CheckQuotation from './views/CheckQuotation.vue'
import QuotationCreationSuccess from './views/QuotationCreationSuccess.vue'
import PaymentSuccess from './views/PaymentSuccess.vue'
import PaymentError from './views/PaymentError.vue'
import router from './router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Root',
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/create-quotation',
      name: 'CreateQuotation',
      component: CreateQuotation,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/check-quotation/:quotationID',
      name: 'CheckQuotation',
      props: true,
      component: CheckQuotation,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/my-documents',
      name: 'MyDocuments',
      component: MyDocuments,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/choose-quotation-action',
      name: 'ChooseQuotationAction',
      component: ChooseQuotationAction,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/get-quotation',
      name: 'GetQuotation',
      component: GetQuotation,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/quotation-creation-success/:quotationID',
      name: 'QuotationCreationSuccess',
      component: QuotationCreationSuccess,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/payment/:quotationID',
      name: 'Payment',
      component: Payment,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/payment-success',
      name: 'PaymentSucces',
      component: PaymentSuccess,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/payment-error',
      name: 'PaymentError',
      component: PaymentError,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  var currentUser = {}
  if (localStorage.getItem('currentUser')) {
    try {
      currentUser = JSON.parse(localStorage.getItem('currentUser'));
    } catch(e) {
      localStorage.removeItem('currentUser');
    }
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (currentUser.uid === undefined && to.path !== '/login') {
      next({
        path: '/login'
      })
    } else if (!currentUser.hasCompletedWebOnboarding && to.path !== '/settings') {
      next({
        path: '/settings'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})